import styled from "styled-components"
import { DropdownButton, Dropdown } from "react-bootstrap"

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
`
export const PageHeader = styled.div`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    height: ${(props) => props.theme.pageHeaderHeight}px;
    background: ${(props) => props.theme.pageHeaderBackground};
    border-bottom: solid 2px ${(props) => props.theme.pageHeaderBorderColor};
`
export const PageTitle = styled.h2`
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.lg}px;
    font-weight: 500;
    margin-bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    background: ${(props) => props.theme.pageContentBackground};
`
export const PageForm = styled.div<{
    row?: boolean
    noPaddingTop?: boolean
    noPaddingBottom?: boolean
}>`
    display: flex;
    flex-direction: ${(props) => (props.row ? "row" : "column")};
    position: relative;
    padding: ${(props) => `${props.noPaddingTop ? "0" : "15px"} 15px ${props.noPaddingBottom ? "0" : "15px"} 15px`};
`
export const PageMenu = styled.div`
    display: flex;
    flex-direction: row;
    background: ${(props) => props.theme.pageMenuBackground};
`
export const PageMenuButton = styled.div<{
    isActive: boolean
}>`
    display: flex;
    user-select: none;
    padding: 8px 16px;
    line-height: 21px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => (
        props.isActive
            ? props.theme.pageMenuButtonColorActive
            : props.theme.pageMenuButtonColor
    )};
    background: ${(props) => (
        props.isActive
            ? props.theme.pageMenuButtonBackgroundActive
            : "transparent"
    )};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.pageMenuButtonColorActive};
        background: ${(props) => (
        props.isActive
            ? props.theme.pageMenuButtonBackgroundActive
            : props.theme.pageMenuButtonBackgroundHover
    )};
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const PageMenuDropdown = styled(DropdownButton)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        display: flex;
        user-select: none;
        border-radius: 0;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        padding: 8px 34px 8px 16px;
        line-height: 21px;
        text-transform: uppercase;
        font-weight: 600;
        font-size: ${(props) => props.theme.fontSizes.sm}px;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.pageMenuButtonColorActive} !important;
        background: ${(props) => props.theme.pageMenuButtonBackgroundActive} !important;

        &::after {
            content: "";
            display: block;
            border-top: 4px solid ${(props) => props.theme.pageMenuButtonColorActive};
            border-right: 4px solid transparent;
            border-bottom: 0;
            border-left: 4px solid transparent;
            position: absolute;
            top: 17px;
            right: 14px;
        }
    }

    & > .dropdown-menu {
        max-height: 400px;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0;
        border-radius: 0;
        transform: translate(0px, 37px) !important;
        border: 1px solid ${(props) => props.theme.pageMenuDropdownBackground};
        background: ${(props) => props.theme.pageMenuDropdownBackground};
    }
`
export const PageMenuDropdownItem = styled(Dropdown.Item)`
    display: block;
    padding: 5px 24px;
    text-decoration: none;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    color: ${(props) => props.theme.pageMenuDropdownItemColor};
    background: transparent;
    transition: ${(props) => props.theme.defaultTransition};

    &:focus {
        outline: none;
        background: transparent;
        color: ${(props) => props.theme.pageMenuDropdownItemColor};
    }

    &:hover {
        text-decoration: none;
        color: ${(props) => props.theme.pageMenuDropdownItemColorHover};
        background: ${(props) => props.theme.pageMenuDropdownItemBackgroundHover};
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const Tab = styled.div<{
    show: boolean
    noGrow?: boolean
}>`
    display: ${(props) => (props.show ? "flex" : "none")};
    flex-direction: column;
    flex-grow: ${(props) => (props.noGrow ? 0 : 1)};
    position: relative;
`
export const Delimiter = styled.div<{
    size?: "xs" | "sm" | "md"
}>`
    display: flex;
    flex-direction: row;
    height: 0;
    margin: ${(props) => {
        switch (props.size) {
            case "xs":
                return "5px 0 10px"
            case "sm":
                return "10px 0 15px"
            case "md":
            default:
                return "15px 0 20px"
        }
    }};
    border-top: 1px solid ${(props) => props.theme.delimeterColor};
`
